import i18n from "i18next";

export const getRecommendationLanguage = ():
  | "cs-CZ"
  | "en-US"
  | "sk-SK"
  | "pl-PL" => {
  if (i18n.language === "cs") {
    return "cs-CZ";
  }

  if (i18n.language === "sk") {
    return "sk-SK";
  }

  if (i18n.language === "pl") {
    return "pl-PL";
  }

  return "en-US";
};
